import { render, staticRenderFns } from "./InputTel.vue?vue&type=template&id=870c0006&"
import script from "./InputTel.vue?vue&type=script&lang=js&"
export * from "./InputTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports